import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap'
import { connect } from 'react-redux'
import ComponentCreditCardInput from './component_credit_card_input'

import { } from '../actions'
import { } from '../utils'

import NavHeader from './navheader'
import SubMenu from './submenu'
import Footer from './footer'

class TestComponentPage extends Component {

    state = {
        name: '',
        input1: '',
        input2: '',
        input3: '',
        input4: '',
        input5: '',
        input6: '',
        input7: '',
    }

    setParentState(key, value) {
        let newState = {}
        newState[key] = value
        this.setState({ ...newState })
    }

    onSubmitClick() {
        let bool = true
        let values = {}
        this.state.name != '' ? values = { name: this.state.name } : bool = false
        for (let i = 1; i < 5; i++) {
            let state = 'input' + i
            this.state[state].length == 4 ? '' : bool = false
        }
        for (let i = 5; i < 7; i++) {
            let state = 'input' + i
            this.state[state].length == 2 ? '' : bool = false
        }
        this.state.input7.length == 3 ? '' : bool = false
        if (bool) {
            values['number'] = this.state.input1 + this.state.input2 + this.state.input3 + this.state.input4
            values['expiration_month'] = this.state.input5
            values['expiration_year'] = this.state.input6
            values['security_code'] = this.state.input7

            // console.log(values)

            this.setState({
                name: '', input1: '', input2: '', input3: '',
                input4: '', input5: '', input6: '', input7: ''
            })
        } else {
            window.alert('กรุณากรอกข้อมูลให้ครบถ้วนถูกต้อง')
        }
    }

    render() {
        return (
            <div>
                <NavHeader history={this.props.history} />
                <SubMenu ref={d => this.submenu = d} history={this.props.history} />
                <div className='container main-bg'>
                    <div style={{ marginLeft: 10, marginRight: 10 }}>
                        <h1>TestJa: </h1>
                        <ComponentCreditCardInput setParentState={this.setParentState.bind(this)}
                            input1={this.state.input1} input2={this.state.input2}
                            input3={this.state.input3} input4={this.state.input4}
                            input5={this.state.input5} input6={this.state.input6}
                            input7={this.state.input7} name={this.state.name}
                        />
                        <button onClick={() => this.onSubmitClick()} className='btn btn-success'>test</button>
                        <br /><br />
                    </div>
                </div>
                <Footer />
            </div>
        )
    }

}

export default connect(null, {})(TestComponentPage)



// WEBPACK FOOTER //
// ./src/components/test_component_credit_card_input.js